"use client";

import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";

const LIVE_CHANNELS = [
  { label: "Website chat", plan: "Intern" },
  { label: "Browser voice", plan: "Intern" },
  { label: "Phone", plan: "Associate" },
  { label: "Email", plan: "Associate" },
  { label: "Video", plan: "Associate" },
  { label: "SMS", plan: "Professional" },
] as const;

export function SiteGlueHomeChannels() {
  return (
    <HomeSection id="every-channel" tone="white" className="py-14 sm:py-16">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Channels</HomeEyebrow>
        <HomeHeading className="mx-auto">The conversations you can turn on today.</HomeHeading>
        <HomeLead className="mx-auto">
          Website chat and browser voice are on Intern. Phone, email, and video are on Associate.
          SMS is on Professional. Each plan includes a 15-day trial.
        </HomeLead>
      </FadeIn>
      <ul className="mt-8 flex flex-wrap items-center justify-center gap-2">
        {LIVE_CHANNELS.map((channel) => (
          <li
            key={channel.label}
            className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm font-medium text-slate-800"
          >
            {channel.label}
            <span className="ml-1.5 text-xs font-normal text-slate-500">{channel.plan}</span>
          </li>
        ))}
      </ul>
      <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-slate-500">
        WhatsApp and Messenger are not available yet.
      </p>
    </HomeSection>
  );
}
